<template>
  <a-layout-sider
      :class="['sider', isDesktop ? null : 'shadow', theme, fixSiderbar ? 'ant-fixed-sidemenu' : null ]"
      width="256px"
      v-model:collapsed="sideCollapsed"
      :trigger="null"
      collapsible
  >
    <logo :show-title="!sideCollapsed"/>
    <Menu :collapsed="collapsed" :menu="menus" :theme="theme" :mode="mode"></Menu>
  </a-layout-sider>
</template>

<script>
import {isDesktop} from '@/utils/device'
import Menu from "./Menu";
import Logo from "@/components/Tools/Logo";
import {computed, ref, watch} from "vue";
import {settingStore} from "@/store/setting";

export default {
  name: "SideMenu",
  components: {
    Menu,
    Logo
  },
  props: {
    mode: {
      type: String,
      required: false,
      default: 'inline'
    },
    theme: {
      type: String,
      required: false,
      default: 'dark'
    },
    collapsed: {
      type: Boolean,
      required: false,
      default: false
    },
    menus: {
      type: Array,
      required: true
    }
  },
  setup(props) {
    const sideCollapsed = ref(props.collapsed);
    const userStore = settingStore();

    watch(
        () => props.collapsed,
        (newVal) => {
          sideCollapsed.value = newVal;
        }
    )

    return {
      isDesktop,
      fixSiderbar: computed(() => userStore.fixSiderbar),
      sideCollapsed,
    }
  }
}
</script>

<style scoped>

</style>